import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { GenerateProductDescriptionByAiArgs } from '@ztechapps/common.contract'

const defaultQuery = gql`
  mutation generateProductDescriptionByAi($input: GenerateProductDescriptionByAiArgs!) {
    generateProductDescriptionByAi(input: $input)
  }
`

export const useGenerateProductDescriptionByAi = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? defaultQuery

  return useMutation<{ generateProductDescriptionByAi: string }, GenerateProductDescriptionByAiArgs>({
    query,
    ...props,
  })
}
